/** @format */

import { api } from 'utility';
import {
  getBusinessDealerServiceUrl,
  getToggleDealerUrl,
  getDealingListUrl,
  getAddOrToggleDealerProductPermissionUrl,
  getDealingProductListUrl,
  getDealerProductListUrl,
} from 'URLs';
class DealerService {
  getDealerList(params) {
    return api.get(getBusinessDealerServiceUrl(), { params }).then((res) => res.data);
  }

  addDealer(item) {
    return api.post(getBusinessDealerServiceUrl(), item);
  }

  updateDealer(item) {
    return api.put(getBusinessDealerServiceUrl(), item);
  }

  toggleDealerStatus(dealerBizId, enable) {
    return api.post(getToggleDealerUrl(dealerBizId), null, { params: { enable } });
  }

  getDealingList(params) {
    return api.get(getDealingListUrl(), { params }).then((res) => res.data);
  }

  getDealerAllowedProductsList(params) {
    return api.get(getDealerProductListUrl(), { params }).then((res) => res.data);
  }

  getDealingAllowedProductsList(params) {
    return api.get(getDealingProductListUrl(), { params }).then((res) => res.data);
  }

  addDealerProductPermission({ dealerBizId, productId }) {
    return api.post(getAddOrToggleDealerProductPermissionUrl(dealerBizId, productId));
  }

  toggleDealerProductPermission({ dealerBizId, productId, enable }) {
    return api.put(getAddOrToggleDealerProductPermissionUrl(dealerBizId, productId), null, {
      params: { enable },
    });
  }
}

export default new DealerService();
